import axios from 'axios';
import lib from '@/lib';

import AuthModel from '@/models/AuthModel';

export default class AppModel
{
	/**
	 * Конструктор
	 */
	constructor()
	{
		this.title = '';
		
		this.auth = new AuthModel();
		
		this.preloader = true;
		
		this.productsCategories = [];
		
		// wishlist
		this.wishlistProducts = localStorage.getItem('wishlistProducts') ? JSON.parse(localStorage.getItem('wishlistProducts')) : [];
		/*this.wishlistProducts = [
			{
				id: 1,
				name: 'Gaming Headphone',
				count: 1,
				oldPrice: 10000,
				price: 85000,
				poster: '/assets/media/images/cart-image-1.png',
			},
			{
				id: 2,
				name: 'Samsung S21 Ultra',
				count: 1,
				oldPrice: null,
				price: 350000,
				poster: '/assets/media/images/cart-image-2.png',
			},
		];*/
		
		// basket
		this.basketProducts = localStorage.getItem('basketProducts') ? JSON.parse(localStorage.getItem('basketProducts')) : [];
		/*this.basketProducts = [
			{
				id: 1,
				name: 'Gaming Headphone',
				count: 1,
				oldPrice: 10000,
				price: 85000,
				poster: '/assets/media/images/cart-image-1.png',
			},
			{
				id: 2,
				name: 'Samsung S21 Ultra',
				count: 1,
				oldPrice: null,
				price: 350000,
				poster: '/assets/media/images/cart-image-2.png',
			},
		];*/
		
		// checkout
		this.checkoutProducts = [
			/*{
				id: 1,
				name: 'Elite Audio Gear',
				count: 1,
				price: 80000,
				poster: '/assets/media/images/cart-image-1.png',
			},
			{
				id: 2,
				name: 'Samsung S21 Ultra',
				count: 1,
				price: 350000,
				poster: '/assets/media/images/cart-image-2.png',
			},*/
		];
		
		this.coupons = [];
		this.appliedCoupon = {
			code: '',
			discount: 0,
		};
	}
	
	/**
	 * Set page title
	 */
	setPageTitle(title)
	{
		this.title = title;
		document.title = title;
	}
	
	pageReload()
	{
		document.location.reload();
	}
	
	hasProductInBasket(id)
	{
		return this.basketProducts.some(product => product.id == id);
	}
	
	getProductFromBasket(id)
	{
		return this.basketProducts.find(product => product.id == id);
	}
	
	addProductToBasket(product, count = 1)
	{
		this.basketProducts.push({ ...product, count });
		localStorage.setItem('basketProducts', JSON.stringify(this.basketProducts));
	}
	
	deleteProductFromBasket(id, hasConfirm = true)
	{
		if (!hasConfirm || (hasConfirm && confirm('Вы уверены, что хотите удалить этот товар из корзины?'))) {
			const index = this.basketProducts.findIndex(product => product.id == id);
			if (index !== -1) {
				this.basketProducts.splice(index, 1);
				localStorage.setItem('basketProducts', JSON.stringify(this.basketProducts));
			}
		}
	}
	
	toggleProductBasket(product, count = 1)
	{
		if (this.hasProductInBasket(product.id)) {
			this.deleteProductFromBasket(product.id, false);
		} else {
			this.addProductToBasket(product, count);
		}
	}
	
	hasProductInWishlist(id)
	{
		return this.wishlistProducts.some(product => product.id == id);
	}
	
	getProductFromWishlist(id)
	{
		return this.wishlistProducts.find(product => product.id == id);
	}
	
	addProductToWishlist(product, count = 1)
	{
		this.wishlistProducts.push({ ...product, count });
		localStorage.setItem('wishlistProducts', JSON.stringify(this.wishlistProducts));
	}
	
	deleteProductFromWishlist(id, hasConfirm = true)
	{
		if (!hasConfirm || (hasConfirm && confirm('Вы уверены, что хотите удалить этот товар из избранного?'))) {
			const index = this.wishlistProducts.findIndex(product => product.id == id);
			if (index !== -1) {
				this.wishlistProducts.splice(index, 1);
				localStorage.setItem('wishlistProducts', JSON.stringify(this.wishlistProducts));
			}
		}
	}
	
	toggleProductWishlist(product, count = 1)
	{
		if (this.hasProductInWishlist(product.id)) {
			this.deleteProductFromWishlist(product.id, false);
		} else {
			this.addProductToWishlist(product, count);
		}
	}
	
	checkCoupon(code)
	{
		const foundCoupon = this.coupons.find(coupon => coupon.code === code);
		if (foundCoupon) {
			this.appliedCoupon.code = foundCoupon.code;
			this.appliedCoupon.discount = foundCoupon.discount;
			return true;
		}
		return false;
	}
	
	getAllChildCategoryIds(categoryId)
	{
		const result = [categoryId];
		const findChildren = (id) => {
			this.productsCategories.forEach(cat => {
				if (cat.parent_id === id) {
					result.push(cat.id);
					findChildren(cat.id);
				}
			});
		};
		findChildren(categoryId);
		return result;
	}
	
	/**
	 * Изменение анкетных данных пользователя
	 */
	async doChangeQuestionary(params = {})
	{
		try {
			const response = await axios.post('/api/user/change-questionary', params, {
				params: {
					//lang: this.getLang(),
				},
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					error: error.message,
				};
			}
		}
	}
	
	/**
	 * Изменение контактных данных пользователя
	 */
	async doChangeContacts(params = {})
	{
		try {
			const response = await axios.post('/api/user/change-contacts', params, {
				params: {
					//lang: this.getLang(),
				},
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					error: error.message,
				};
			}
		}
	}
	
	/**
	 * Изменение пароля пользователя
	 */
	async doChangePassword(params = {})
	{
		try {
			const response = await axios.post('/api/user/change-password', params, {
				params: {
					//lang: this.getLang(),
				},
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					error: error.message,
				};
			}
		}
	}
	
	/**
	 * Удаление аккаунта пользователя
	 */
	async doDeleteAccount()
	{
		try {
			const response = await axios.post('/api/user/delete', {}, {
				params: {
					//lang: this.getLang(),
				},
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					error: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение списка купонов
	 */
	async doGetCoupons(params = {})
	{
		//params['lang'] = this.getLang();
		
		try {
			const response = await axios.get('/api/coupons', {
				params,
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение данных о купоне по его id
	 */
	async doGetCoupon(coupon_id)
	{
		try {
			const response = await axios.get('/api/coupons/' + coupon_id, {
				params: {
					//lang: this.getLang(),
				},
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Добавление купона
	 */
	async doAddCoupon(params = {})
	{
		try {
			const response = await axios.post('/api/coupons', params, {
				params: {
					//lang: this.getLang(),
				},
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Изменение данных о купоне по его id
	 */
	async doEditCoupon(coupon_id, params = {})
	{
		try {
			const response = await axios.post('/api/coupons/' + coupon_id, params, {
				params: {
					//lang: this.getLang(),
				},
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Удаление купона по его id
	 */
	async doDeleteCoupon(coupon_id)
	{
		try {
			const response = await axios.delete('/api/coupons/' + coupon_id, {
				params: {
					//lang: this.getLang(),
				},
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение списка новостей
	 */
	async doGetNews(params = {})
	{
		//params['lang'] = this.getLang();
		
		try {
			const response = await axios.get('/api/news', {
				params,
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение данных о новости по её id
	 */
	async doGetNewsitem(item_id)
	{
		try {
			const response = await axios.get('/api/news/' + item_id, {
				params: {
					//lang: this.getLang(),
				},
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Добавление задачи
	 */
	async doAddNewsitem(params = {})
	{
		const formData = new FormData();
		for (const key in params) {
			if (params.hasOwnProperty(key)) {
				formData.append(key, params[key]);
			}
		}
		
		try {
			const response = await axios.post('/api/news', formData, {
				params: {
					//lang: this.getLang(),
				},
				headers: {
					'Content-Type': 'multipart/form-data',
				},
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Изменение данных о новости по её id
	 */
	async doEditNewsItem(item_id, params = {})
	{
		const formData = new FormData();
		for (const key in params) {
			if (params.hasOwnProperty(key)) {
				formData.append(key, params[key]);
			}
		}
		
		try {
			const response = await axios.post('/api/news/' + item_id, formData, {
				params: {
					//lang: this.getLang(),
				},
				headers: {
					'Content-Type': 'multipart/form-data',
				},
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Удаление новости по её id
	 */
	async doDeleteNewsItem(item_id)
	{
		try {
			const response = await axios.delete('/api/news/' + item_id, {
				params: {
					//lang: this.getLang(),
				},
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение списка категорий товаров
	 */
	async doGetProductsCategories(params = {})
	{
		//params['lang'] = this.getLang();
		
		try {
			const response = await axios.get('/api/products/categories', {
				params,
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение списка категорий товаров для главной страницы
	 */
	async doGetProductsCategoriesMainpage(params = {})
	{
		//params['lang'] = this.getLang();
		
		try {
			const response = await axios.get('/api/products/categories/mainpage', {
				params,
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение данных о категории товаров по её id
	 */
	async doGetProductsCategory(category_id)
	{
		try {
			const response = await axios.get('/api/products/categories/' + category_id, {
				params: {
					//lang: this.getLang(),
				},
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Добавление категории товаров
	 */
	async doAddProductsCategory(params = {})
	{
		try {
			const response = await axios.post('/api/products/categories', params, {
				params: {
					//lang: this.getLang(),
				},
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Изменение данных о категории товаров по её id
	 */
	async doEditProductsCategory(category_id, params = {})
	{
		try {
			const response = await axios.post('/api/products/categories/' + category_id, params, {
				params: {
					//lang: this.getLang(),
				},
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Удаление категории товаров по её id
	 */
	async doDeleteProductsCategory(category_id)
	{
		try {
			const response = await axios.delete('/api/products/categories/' + category_id, {
				params: {
					//lang: this.getLang(),
				},
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение списка товаров
	 */
	async doGetProducts(params = {})
	{
		//params['lang'] = this.getLang();
		
		try {
			const response = await axios.get('/api/products', {
				params,
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение данных о товаре по его id
	 */
	async doGetProduct(product_id)
	{
		try {
			const response = await axios.get('/api/products/' + product_id, {
				params: {
					//lang: this.getLang(),
				},
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Добавление товара
	 */
	async doAddProduct(params = {})
	{
		const formData = new FormData();
		for (const key in params) {
			if (params.hasOwnProperty(key)) {
				formData.append(key, params[key]);
			}
		}

		try {
			const response = await axios.post('/api/products', formData, {
				params: {
					//lang: this.getLang(),
				},
				headers: {
					'Content-Type': 'multipart/form-data',
				},
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Изменение данных о товаре по его id
	 */
	async doEditProduct(product_id, params = {})
	{
		const formData = new FormData();
		for (const key in params) {
			if (params.hasOwnProperty(key)) {
				formData.append(key, params[key]);
			}
		}
		
		try {
			const response = await axios.post('/api/products/' + product_id, params, {
				params: {
					//lang: this.getLang(),
				},
				headers: {
					'Content-Type': 'multipart/form-data',
				},
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Удаление товара по его id
	 */
	async doDeleteProduct(product_id)
	{
		try {
			const response = await axios.delete('/api/products/' + product_id, {
				params: {
					//lang: this.getLang(),
				},
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение списка изображений товара
	 */
	async doGetProductImages(product_id, params = {})
	{
		//params['lang'] = this.getLang();
		
		try {
			const response = await axios.get('/api/products/' + product_id + '/images', {
				params,
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Добавление и загрузка изображения товара
	 */
	async doAddProductImage(product_id, params = {})
	{
		const formData = new FormData();
		for (const key in params) {
			if (params.hasOwnProperty(key)) {
				formData.append(key, params[key]);
			}
		}

		try {
			const response = await axios.post('/api/products/' + product_id + '/images', formData, {
				params: {
					//lang: this.getLang(),
				},
				headers: {
					'Content-Type': 'multipart/form-data',
				},
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Установка изображения товара в качестве постера
	 */
	async doSetProductPoster(product_id, image_id)
	{
		try {
			const response = await axios.post('/api/products/' + product_id + '/poster/' + image_id, {}, {
				params: {
					//lang: this.getLang(),
				},
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Удаление товара по его id
	 */
	async doDeleteProductImage(product_id, image_id)
	{
		try {
			const response = await axios.delete('/api/products/' + product_id + '/images/' + image_id, {
				params: {
					//lang: this.getLang(),
				},
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение списка пользователей
	 */
	async doGetUsers(params = {})
	{
		//params['lang'] = this.getLang();
		
		try {
			const response = await axios.get('/api/users', {
				params,
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
	
	/**
	 * Удаление пользователя по его id
	 */
	async doDeleteUser(user_id)
	{
		try {
			const response = await axios.delete('/api/users/' + user_id, {
				params: {
					//lang: this.getLang(),
				},
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					message: error.message,
				};
			}
		}
	}
}
